import { createContext, useState, useEffect } from 'react'
import { auth, loginWithEmail, registerWithEmail, logOut } from '../services/firebase'
import { onAuthStateChanged } from 'firebase/auth'

export const AuthContext = createContext(null)

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      setUser(user)
      setLoading(false)
    })

    return () => unsubscribe()
  }, [])

  const login = async (email, password) => {
    try {
      setError(null)
      setLoading(true)
      await loginWithEmail(email, password)
    } catch (error) {
      setError(getErrorMessage(error.code))
      throw error
    } finally {
      setLoading(false)
    }
  }

  const register = async (email, password, displayName) => {
    try {
      setError(null)
      setLoading(true)
      await registerWithEmail(email, password, displayName)
    } catch (error) {
      setError(getErrorMessage(error.code))
      throw error
    } finally {
      setLoading(false)
    }
  }

  const logout = async () => {
    try {
      await logOut()
    } catch (error) {
      console.error('Logout error:', error)
      throw error
    }
  }

  const getErrorMessage = (code) => {
    switch (code) {
      case 'auth/email-already-in-use':
        return 'Este email ya está registrado'
      case 'auth/invalid-email':
        return 'Email inválido'
      case 'auth/weak-password':
        return 'La contraseña debe tener al menos 6 caracteres'
      case 'auth/user-not-found':
        return 'No existe una cuenta con este email'
      case 'auth/wrong-password':
        return 'Contraseña incorrecta'
      case 'auth/invalid-credential':
        return 'Email o contraseña incorrectos'
      default:
        return 'Error de autenticación'
    }
  }

  const value = {
    user,
    loading,
    error,
    login,
    register,
    logout,
    isAuthenticated: !!user
  }

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  )
}
